export default "__VITE_ASSET__CeMKzyR1__"